import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

function FormReactSelect({
  name,
  label,
  value,
  onChange,
  onSetFieldValue,
  onChangeCallback,
  options,
  isLoading,
  isSearchable,
  error,
  required,
}) {
  const handleChange = (val) => {
    if (typeof onChange === 'function') {
      onChange((state) => ({
        ...state,
        [name]: val,
      }));
    }
    if (typeof onSetFieldValue === 'function') {
      onSetFieldValue(name, val);
    }
  };
  return (
    <div className="flex flex-col">
      <label className="mb-2 font-medium text-gray-500">
        <span>{label}</span>
        {required && (
          <span className="ml-1 font-light border-gray text-red-500">*</span>
        )}
      </label>
      <Select
        name={name}
        options={options}
        isLoading={isLoading}
        isSearchable={isSearchable}
        onChange={(val) => {
          handleChange(val?.value);
          onChangeCallback(val);
        }}
        value={options.find((c) => c.value === value && c.value !== '')}
        components={{
          IndicatorSeparator: () => null,
        }}
        styles={{
          control: (provided) => ({
            ...provided,
            boxShadow: 'none',
            borderColor: error ? 'rgb(252, 165, 165)' : ' rgb(203, 213, 225)',
            padding: '.25rem',
            fontSize: '0.875rem',
            borderRadius: '1rem',
          }),
          option: (provided) => ({
            ...provided,
            fontSize: '0.875rem',
            minHeight: '2.4rem',
          }),
          placeholder: (provided) => ({
            ...provided,
            fontSize: '0.875rem',
            color: '#a0a7b2',
          }),
        }}
      />
    </div>
  );
}

FormReactSelect.defaultProps = {
  isLoading: false,
  onChange: false,
  onSetFieldValue: false,
  error: null,
  required: false,
  isSearchable: false,
  onChangeCallback: () => {},
};

FormReactSelect.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  onSetFieldValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
        .isRequired,
    })
  ).isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  required: PropTypes.bool,
  isSearchable: PropTypes.bool,
  onChangeCallback: PropTypes.instanceOf(Function),
};

export default FormReactSelect;
